<template>
  <!-- 普本院校列表 用于关联使用 -->
  <div class="table_dialog">
    <el-table
      class="table"
      v-loading="loading"
      ref="multipleTableRef"
      :data="tableData"
      max-height="450px"
      border
      style="width:100%;margin-top:10px"
      :header-cell-style="{ background: '#f5f7fa' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <!-- <el-table-column
        fixed
        prop="id"
        label="id"
        width="80"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              scope.row.oldId ? 'oldId为:' + scope.row.oldId : 'oldId为:空'
            "
            placement="top-start"
          >
            <span>{{ scope.row.id }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="name"
        label="院校名称"
        min-width="200"
        align="left"
        :show-overflow-tooltip="true"
        inputSearch="true"
      >
        <template #header>
          <el-popover placement="bottom" :width="300" trigger="click">
            <template #reference>
              <div>
                <span class="search-title">院校名称</span>
                <el-icon>
                  <Search />
                </el-icon>
              </div>
            </template>
            <el-input
              v-model="nameInput"
              class="m-2"
              placeholder="请输入院校名称搜索"
              size="large"
              clearable
              @clear="getpbSchoolData('search')"
            >
              <template #suffix>
                <el-icon @click="getpbSchoolData('search')" clearable>
                  <Search />
                </el-icon>
              </template>
            </el-input>
          </el-popover>
        </template>
        <template #default="scope">
          <el-image
            v-if="/.(png|jpg|jpeg|gif|JPG)$/g.test(scope.row.logoPath)"
            style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
            :src="scope.row.logoPath"
            :preview-src-list="[scope.row.logoPath]"
            fit="cover"
            close-on-press-escape
            hide-on-click-modal
          />
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cityAddress"
        label="所属城市"
        width="180"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span :class="scope.row.areaName ? '' : 'gray'">
            {{ scope.row.areaName ? scope.row.areaName : "未设置" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="natureName"
        label="院校性质"
        width="180"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #header>
          <el-popover placement="bottom" :width="200" trigger="click">
            <template #reference>
              <div>
                <span class="search-title">院校性质</span>
                <el-icon>
                  <ArrowDown />
                </el-icon>
              </div>
            </template>
            <el-select
              v-model="natureValue"
              class="m-2"
              placeholder="请选择院校性质"
              size="large"
              clearable
              @change="getpbSchoolData('search')"
            >
              <el-option
                v-for="item in natureList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-popover>
        </template>
        <template #default="scope">
          <span
            :class="
              isNull(scope.row.natureStr) == true ||
              scope.row.natureStr == '未设置'
                ? 'gray'
                : ''
            "
          >
            {{
              isNull(scope.row.natureStr) == true ||
              scope.row.natureStr == "未设置"
                ? "未设置"
                : scope.row.natureStr
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="schoolTypesName"
        label="院校类别"
        width="180"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #header>
          <el-popover placement="bottom" :width="200" trigger="click">
            <template #reference>
              <div>
                <span class="search-title">院校类别</span>
                <el-icon>
                  <ArrowDown />
                </el-icon>
              </div>
            </template>
            <el-select
              v-model="typeValue"
              class="m-2"
              placeholder="请选择院校类别"
              size="large"
              clearable
              @change="getpbSchoolData('search')"
            >
              <el-option
                v-for="item in typesList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-popover>
        </template>
        <template #default="scope">
          <span
            :class="
              isNull(scope.row.categoryNames) == true ||
              scope.row.schoolTypesName == '未设置'
                ? 'gray'
                : ''
            "
          >
            {{
              isNull(scope.row.categoryNames) == true ||
              scope.row.categoryNames == "未设置"
                ? "未设置"
                : scope.row.categoryNames
            }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="choose_bom">
    <span style="margin-right: 10px" v-if="multipleSelection.length > 0"
      >已选择[
      <b class="select_red" style="font-size: 16px">{{
        multipleSelection.length
      }}</b>
      ]个普本院校</span
    >
    <span style="margin-right: 10px" v-else>请先选择普本院校</span>
    <div style="font-size: 16px; float: right">
      <el-button @click="closeDialog($event)" size="large">取消</el-button>
      <el-button size="large" type="primary" @click="clickTrue($event)"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  getAllSchoolPtNature,
  getAllSchoolPtTypes,
  getConditionsList,
} from "network/pbSchool.js";
import { reactive, onMounted, watch, toRefs, ref, toRaw, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { isNull, lostFocus } from "common/utils.js";

export default {
  name: "PbSchoolRelevancy",
  props: { idsArray: Array,type:Number },
  components: {},
  emits: { "change-pbschool": null, "close-dialog": null },
  setup(props, { emit }) {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      tableData: [],
      // 表格是否在加载中
      loading: true,
      nameInput: null, //筛选 普本院校名称
      natureValue: null, //筛选 普本院校性质
      natureList: [], //普本院校性质下拉选项
      typeValue: null, //筛选 普本院校类别
      typesList: [], //普本院校类别下拉选项
      multipleSelection: [], //选中行数据
      selectIds: [],
    });
    const multipleTableRef = ref(null);
    // 监听父组件传递props
    // watch(props.ids, (newVal, oldVal) => {
    //   // nextTick(() => {
    //   //   changeSelRow(JSON.parse(JSON.stringify(newValue)));
    //   // });
    //   if (!newVal || !Array.isArray(newVal)) return false;
    //   //如果新传递的对象是已选就没必要重复加载
    //   if (newVal == data.selectIds) return false;
    //   data.selectIds = newVal;
    //   console.log(data.selectIds, "请求普本院校列表数据");
    //   this.getpbSchoolData(); //请求普本院校列表数据
    // });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      data.selectIds = JSON.parse(JSON.stringify(props.idsArray));
        getNatureData(); //获取院校性质
      getTypesData(); //获取院校类别
      getpbSchoolData(""); //请求普本院校列表数据
    });
    //初始化选中的行
    function changeSelRow(ids) {
      if (ids) {
        //1 先全部取消
        data.tableData.forEach((item) => {
          multipleTableRef.value.toggleRowSelection(item, false);
        });
      }
      // 赋值选中行数据
      data.multipleSelection = ids;
      // 2.再重新选中父组件传过来存在的数据
      data.tableData.forEach((item) => {
        ids.forEach((subItem) => {
          if (item.id === subItem) {
            multipleTableRef.value.toggleRowSelection(item, true);
          }
        });
      });
    }

    function getNatureData() {
      getAllSchoolPtNature()
        .then((res) => {
          if (res.code == 1) {
            data.natureList = res.result;
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    function getTypesData() {
      getAllSchoolPtTypes()
        .then((res) => {
          if (res.code == 1) {
            data.typesList = res.result;
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 获取列表
    const getpbSchoolData = (type) => {
      data.loading = true;
      const obj = {
        schoolPtSelect: data.selectIds || null,
        name: data.nameInput,
        nature: data.natureValue||0,
        areaId: data.typeValue||0,
      };
      getConditionsList(obj)
        .then((result) => {
             if (result && result.code == 1) {
            data.loading = false;
            data.tableData = toRaw(result.result);
            nextTick(() => {
              changeSelRow(data.selectIds);
            });
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //更新列表 区别于搜索要请求第一页
    const updateList = () => {
      getpbSchoolData("");
    };
    // 表格多选行处理
    const handleSelectionChange = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    // 取消
    const closeDialog = (e) => {
      // lostFocus(e);
      // if (data.multipleSelection && data.multipleSelection.length > 0) {
      //   ElMessageBox.confirm("将取消当前选中普本院校", "取消", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       data.multipleSelection = [];
      //       data.tableData.forEach((item) => {
      //         multipleTableRef.value.toggleRowSelection(item, false);
      //       });
      //       emit("close-dialog");
      //     })
      //     .catch(() => {});
      // } else {
        emit("close-dialog");
      // }
    };
    //确定选中
    const clickTrue = (e) => {
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择普本院校");
      } else {
        // 新数组,用来装数据
        var newArr = [];
        toRaw(data.multipleSelection).map(function (sel, index) {
          var sevm = {};
          sevm["id"] = sel.id;
          sevm["typeName"] = "普本";
           sevm["type"] =JSON.parse(JSON.stringify(props.type));
          sevm["name"] = sel.name;
          newArr[index] = sevm;
        });
        var ids = [];
        newArr.map((org) => {
          ids.push(org.id);
        });
        data.selectIds = ids;
        emit("change-pbschool", newArr);
        emit("close-dialog");
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      multipleTableRef,
      updateList,
      getpbSchoolData,
      handleSelectionChange,
      closeDialog,
      clickTrue,
      isNull,
    };
  },
};
</script>
  
<style scoped>
.choose_bom {
  margin-top: 30px;
  line-height: 35px;
}
.select_red {
  color: red;
}
>>> .el-form-item--large .el-form-item__content {
  line-height: 23px !important;
}
</style>